import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { Timetable } from 'timetable-model';
import { getListRowLink } from 'gossamer-unified';

export const TimetableUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(Timetable, params.key);
  const handleExit = () => navigate(getListRowLink(Timetable.listRowLink, params.key));

  return (
    <>
      <PageTitle verb="Update" entity={Timetable} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/timetable-update"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: { type: 'update-single', entity: Timetable, record },
        }}
      >
        <Update valuesKey="main" entity={Timetable} />
      </FormManager>
    </>
  );
};
